class HTCart {
  constructor() {
    this.drawer = document.querySelector('cart-drawer');

    if (!this.drawer) return;

    this.isReady = false;

    this.init();
  }

  init() {
    if (this.isReady) return;

    this.isReady = true;

    console.log('HT Cart iniciado');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.HTCart = new HTCart();
});